import {
  Flex,
  FormControl,
  FormLabel,
  Stack,
  Switch,
  useColorModeValue,
  Select,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

import Card from 'components/card/Card';

import TextField from 'components/fields/TextField';

import { onFieldContentModified } from '../../../../../../store/preview/previewSlice';
import { useDispatch } from 'react-redux';
import { Dispatch } from '@reduxjs/toolkit'; // Import Dispatch type from @reduxjs/toolkit

interface Badge {
  gasId: number;
  gasAssetImage: string;
  gasAssetName: string;
}

const ReflectionScreen: React.FC<{
  handleChange: (e: any) => void;
  formData: any;

  setFormData: React.Dispatch<React.SetStateAction<any>>;
  setReflection: any;
  handleReflectionInput: any;
  reflectionQuestions: any;
  reflectionQuestionsdefault: any;
  handlesaveReflection: any;
  setReflectionQuestions: any;
}> = ({
  handleChange,
  formData,
  setFormData,
  setReflection,
  handleReflectionInput,
  reflectionQuestions,
  reflectionQuestionsdefault,
  handlesaveReflection,
  setReflectionQuestions,
}) => {
  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const [showTextArea, setTexArea] = useState(4);
  const [showTextarea, setShowTextarea] = useState('');
  const [reflectionQuestionsData, setReflectionQuestionsData] = useState({
    ref1: 'What were your biggest learnings?',
    ref2: 'How can you apply these learnings back at work?',
    ref3: "What's one thing you learned about your mindset?",
    ref4: "What's one thing you are committing to change?",
  });
  const [arra, setArra] = useState([]);
  const [characterCount, setCharacterCount] = useState<number[]>(
    Array.from({ length: showTextArea }, (_, index) =>
      reflectionQuestions[`ref${index + 1}`]?.length
        ? 90 - reflectionQuestions[`ref${index + 1}`]?.length
        : 90,
    ),
  );
  const Reffunction = () => {
    if (Object.entries(reflectionQuestions).length === 0) {
      setReflectionQuestions(reflectionQuestionsData);
    }
  };
  const dispatch: Dispatch<any> = useDispatch();
  const [lastFocusedValue, setLastFocusedValue] = useState('');
  useEffect(() => {
    // formData
    Reffunction();
  }, []);

  const handleTextReflectionChange = (e: any, index: number) => {
    const inputText = e.target.value;
    const updatedCharacterCount = characterCount.map((count, i) =>
      i === index - 1 ? 90 - inputText.length : count,
    );
    setCharacterCount(updatedCharacterCount);
    handleReflectionInput(e, index + 1);
  };
  const handleArra = (e: any) => {
    const selectedValue = parseInt(e.target.value);
    setTexArea(selectedValue);
    setFormData((prev: any) => ({
      ...prev,
      gameReflectionQuestion: selectedValue,
    }));
    /** Handle the data updation on change to show realtime preview */
    dispatch(
      onFieldContentModified({
        gameId: formData.gameId,
        modifiedField: e.target.name,
        updatedValue: selectedValue,
      }),
    );
    /**End -  Handle the data updation on change to show realtime preview */

    if (selectedValue === 1) {
      setShowTextarea('A');
    } else if (selectedValue === 2) {
      setShowTextarea('AB');
    } else if (selectedValue === 3) {
      setShowTextarea('ABC');
    } else if (selectedValue === 4) {
      setShowTextarea('ABCD');
    } else if (isNaN(selectedValue)) {
      setShowTextarea('E');
    }
    setArra(
      Array.from({ length: e.target.value }, (_, index) => ({
        id: index + 1,
        value: '',
      })),
    );
    setReflection(['']);
  };
  useEffect(() => {
    const selectedValue = parseInt(formData.gameReflectionQuestion);
    setTexArea(selectedValue);

    if (selectedValue === 1) {
      setShowTextarea('A');
    } else if (selectedValue === 2) {
      setShowTextarea('AB');
    } else if (selectedValue === 3) {
      setShowTextarea('ABC');
    } else if (selectedValue === 4) {
      setShowTextarea('ABCD');
    } else if (isNaN(selectedValue)) {
      setShowTextarea('E');
    }

    setArra(
      Array.from({ length: selectedValue }, (_, index) => ({
        id: index + 1,
        value: '',
      })),
    );
    setReflection(['']);
  }, [formData.gameReflectionQuestion]);

  const handleOnBlurValue = (e: any) => {
    const { name, value } = e.target;
    if (lastFocusedValue.trim() !== value) {
      dispatch(
        onFieldContentModified({
          gameId: formData.gameId,
          modifiedField: name,
          updatedValue: value,
        }),
      );
    }
  };

  return (
    <Stack direction="column" gap="20px">
      <Card>
        <FormControl
          display="flex"
          alignItems="center"
          justifyContent={'space-between'}
          mt="10px"
        >
          <FormLabel
            htmlFor="email-"
            mb="10px"
            fontSize="sm"
            fontWeight="bold"
            color={textColorPrimary}
          >
            Show Reflection Screen
          </FormLabel>
          <Switch
            isChecked={
              formData.gameIsShowReflectionScreen === 'true' ? true : false
            }
            color="#fff"
            colorScheme="brandScheme"
            size="md"
            id="gameIsShowReflectionScreen"
            name="gameIsShowReflectionScreen"
            onChange={handleChange}
          />
        </FormControl>
        {/* brindha start */}
        {formData.gameIsShowReflectionScreen === 'true' && (
          <>
            <Flex
              display="flex"
              alignItems="center"
              justifyContent={'space-between'}
              mt="20px"
            >
              <FormLabel
                htmlFor="email-"
                mb="0"
                fontSize="sm"
                fontWeight="bold"
                color={textColorPrimary}
              >
                How many questions would you like?
              </FormLabel>
              <Select
                mb="0px"
                id="Collection"
                isDisabled={
                  formData?.gameIsShowReflectionScreen === 'true' ? false : true
                }
                value={formData.gameReflectionQuestion}
                name="gameReflectionQuestion"
                onChange={handleArra}
                isRequired
                ml="10px" // Add margin between the FormLabel and Select
                width={'15%'}
                h={'25%'}
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
              </Select>
            </Flex>
            <FormControl
              display="flex"
              alignItems="center"
              justifyContent={'space-between'}
              mt="20px"
            >
              <FormLabel
                htmlFor="email-"
                mb="0"
                fontSize="sm"
                fontWeight="bold"
                color={textColorPrimary}
              >
                Make these questions mandatory for the learner
              </FormLabel>
              <Switch
                isChecked={
                  formData.gameIsLearnerMandatoryQuestion === 'true'
                    ? true
                    : false
                }
                disabled={
                  formData?.gameIsShowReflectionScreen === 'true' ? false : true
                }
                color="#fff"
                colorScheme="brandScheme"
                size="md"
                id="gameIsLearnerMandatoryQuestion"
                name="gameIsLearnerMandatoryQuestion"
                onChange={handleChange}
                isRequired
              />
            </FormControl>
          </>
        )}
      </Card>

      {formData.gameIsShowReflectionScreen === 'true' && (
        <Card>
          <Stack gap="20px">
            {Array.from({ length: showTextArea }, (_, index) => (
              <div>
                <TextField
                  key={index}
                  mb="0px"
                  id={`reflectionQuestion${index + 1}`}
                  placeholder={reflectionQuestionsdefault[index]}
                  label={` Question ${index + 1}`}
                  onChange={(e: any) => {
                    handleTextReflectionChange(e, index + 1);
                  }}
                  name={`ref${index + 1}`}
                  onBlur={handleOnBlurValue}
                  onFocus={(e: any) => setLastFocusedValue(e.target.value)}
                  value={reflectionQuestions[`ref${index + 1}`]} // Access the specific question using the index
                  maxLength={90}
                  style={{
                    border:
                      formData.gameIsShowReflectionScreen === 'true' &&
                      !reflectionQuestions[`ref${index + 1}`]
                        ? '1px solid red'
                        : '1px solid #ced4da',
                    // Add other styles as needed
                  }}
                />
                <p style={{ fontSize: '12px', color: 'grey' }}>
                  {characterCount[index]} characters left
                </p>
              </div>
            ))}
          </Stack>
        </Card>
      )}
    </Stack>
  );
};
export default ReflectionScreen;
